import React from "react";
import { Text, Flex, ImageView } from "@thenounproject/lingo-core";
import { Container, InnerSmall } from "../Elements";
import MarketingText from "../MarketingText";

type Testimonial = {
  quote: string;
  name: string;
  position: string;
  company: string;
  profileImage?: string;
};

const TESTIMONIALS: Record<string, Testimonial> = {
  FM: {
    quote:
      "Anybody noticing @Lingo_app quietly becoming the most comprehensive, helpful digital asset manager out there? They keep adding more nifty features that make work easier and I am GRATEFUL <3",
    name: "Francesca Mayr",
    position: "VP, Innovation and Experience",
    company: "GLOBO",
    profileImage: "https://cdn.lingoapp.com/bTe3AKz/testimonial_francesca_mayr.jpg",
  },
  MM: {
    quote:
      "Lingo is a flexible and powerful tool that helps designers and collaborators alike. It strips away vestigial complexity found in other DAM's and gives users the tools and information they need to create powerful on-brand content.",
    name: "Michael Moulton",
    position: "Executive Creative Director",
    company: "Quantum Metric",
    profileImage: "https://cdn.lingoapp.com/YwiKuyR/Micheal Moulton.jpg",
  },
  WHM: {
    quote:
      "Giving team members direct access to brand assets for a project, including important instructions, solves such a big problem for our team.",
    name: "Whitney Hack Williams",
    position: "Creative Director",
    company: "iDesign",
  },
  JH: {
    quote:
      "Lingo makes it so easy to organize all my photos and brand assets without getting bogged down by a distracting interface. I love that I can easily scroll (and search!) through my assets. It's definitely increased my productivity since I don't have to waste so much time finding what I need.",
    name: "Jessica Huizenga",
    position: "Owner",
    company: "The Confetti Bar",
    profileImage: "https://cdn.lingoapp.com/plKIVLY/Jessica Huizenga.jpg",
  },
};

type Props = {
  title?: string;
  subtitle?: string;
  testimonials?: Testimonial[];
};

const TestimonialSection: React.FC<Props> = ({
  title = "Built to Impress",
  subtitle = "Why leading marketers and designers rely on Lingo",
  testimonials = [TESTIMONIALS.FM, TESTIMONIALS.MM, TESTIMONIALS.JH],
}) => {
  return (
    <Container>
      <InnerSmall textAlign="center" first>
        <Text font="marketing.h2">{title}</Text>
        {subtitle && (
          <MarketingText mt="m" font="marketing.bodyLarge">
            {subtitle}
          </MarketingText>
        )}
      </InnerSmall>

      <Flex
        m="0 auto"
        flexWrap="wrap"
        mt="xl"
        maxWidth="1200"
        // templateColumns="3"
        gap="24px"
        variations={{
          "mq.m": { templateColumns: "2" },
          "mq.s": { templateColumns: "1" },
        }}>
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} testimonial={testimonial} />
        ))}
      </Flex>
    </Container>
  );
};

const TestimonialCard: React.FC<{ testimonial: Testimonial }> = ({ testimonial }) => {
  return (
    <Flex
      flexDirection="column"
      p="l"
      background="white"
      borderRadius="8px"
      border="default"
      minWidth={300}
      flex="1"
      justifyContent="space-between">
      <Text font="ui.regular" mb="16px">
        &quot;{testimonial.quote}&quot;
      </Text>
      <Flex alignItems="center">
        <ImageView
          src={testimonial.profileImage}
          width="80px"
          height="80px"
          mr="16px"
          background="grayLightest"
          borderRadius="40px"
          border="2px solid grayLight"
          variations={{
            "mq.xs": { width: "20px", height: "20px", borderRadius: "30px" },
          }}
        />
        <Flex flexDirection="column" alignItems="flex-start" flex="1">
          <Text font="marketing.regularBold">{testimonial.name}</Text>
          <Text font="ui.small" color="grayDarker">
            {testimonial.position}
          </Text>
          <Text font="ui.smallBold" color="grayDarkest">
            {testimonial.company}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TestimonialSection;
